export default __webpack_public_path__ + "img/8b37be937e8edcf8a9aff3abc1015331.svg";